export default __webpack_public_path__ + "static/media/University-Of-Calgary-Logo-2-1024x544.f7ef16dc.png";